import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Grid, TextField } from '@mui/material';
import { Color } from '../../../assets/color';
import * as AuthActions from '../../../redux/actions/authAction';

import '../../login/login.css';

const ResetPassword = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    let [searchParams, setSearchParams] = useSearchParams();
    const query = new URLSearchParams(searchParams);
    const reset_token = query.get('reset-token') || '';
    const role = query.get('role') || '';

    const [inputFieldDetail, setInputFieldDetail] = useState({ password: '' });
    const [inputFieldError, setInputFieldError] = useState({});

    const handleInputFieldDetailError = (input, value) => setInputFieldError((prev) => ({ ...prev, [input]: value }));  //* Handle Input Field : Error
    const handleInputFieldDetail = (event) => setInputFieldDetail({ ...inputFieldDetail, [event?.target?.name]: event?.target?.value });  //* Handle Input Field : Data

    //! Handle Validation
    const handleValidation = () => {
        let isValid = true
        const { password } = inputFieldDetail;

        if (!password) { handleInputFieldDetailError("password", "Please Enter password"); isValid = false }
        return isValid;
    }

    //! Handle Submit
    const handleSubmit = () => {
        const { password } = inputFieldDetail;

        if (handleValidation()) {
            console.log({ ...inputFieldDetail });

            const payload = {
                data: { password, reset_token, role },
                onComplete: () => navigate(role !== 'Partner' ? '/login' : '/login/partner')
            }
            //! Dispatching API For Login 
            dispatch(AuthActions.resetPassword(payload));
        }
    };

    return (
        <div style={{ backgroundSize: 'cover', backgroundRepeat: 'no-repeat', height: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', }}>
            <div className="loginWrapper slideInFromBottomAnimation" style={{ border: `1px solid ${Color.primary}` }}>
                <div style={{ padding: '2rem 0rem 0rem 2rem', maxWidth: '30rem', borderRadius: 20, backgroundColor: 'white', padding: "2rem" }}>
                    <Grid container spacing={2}>
                        <Grid item lg={12} sm={12} md={12} xs={12} >
                            <div style={{ display: 'flex', flexDirection: 'column', }}  >
                                <div style={{ fontSize: '2rem', }}>Reset password</div>
                                <div style={{ fontSize: '1.2rem', marginTop: 10 }}>Enter you new password for reset.</div>
                            </div>
                        </Grid>

                        <Grid item xs={12}>
                            <TextField label={<>Password <span style={{ color: "red" }}>*</span></>} variant="outlined" fullWidth
                                name="password"
                                value={inputFieldDetail?.password}
                                onChange={handleInputFieldDetail}
                                error={inputFieldError.password ? true : false}
                                helperText={inputFieldError.password}
                                onFocus={() => handleInputFieldDetailError("password", null)}
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>

                        <Grid item lg={12} sm={12} md={12} xs={12} >
                            <div onClick={handleSubmit} style={{ padding: '15px 20px', textAlign: 'center', border: `1px solid ${Color.primary}`, borderRadius: '5px', backgroundColor: Color.primary, color: Color.white, fontSize: '16px', cursor: 'pointer' }}>Submit</div>
                        </Grid>
                    </Grid>
                </div>
            </div>
        </div>
    )

}
export default ResetPassword;
